import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import * as yup from 'yup';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const IBAConfig = {
    IBANumber: "",
    BankName: "",
    Branch: "",
    IFSCCode: "",
    AccountName: "",
    AccountNumber: 0,
    AccountType: 0,
    IBAAddress: "",
    ContactNumber: 0,
    AltContactNumber: 0,
    EmailID: "",
    AltEmailID: "",
    Website: "",
    PANNumber: "",
    GSTNumber: "",
    IBATerms: "",
    IBAFileName: null
}

const IBASchema = yup.object().shape({
    AltEmailID: yup.string().trim().email(),
    EmailID: yup.string().required().email(),
    ContactNumber: yup.number().required(),
    AltContactNumber: yup.number()
});

const IBA = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [IBAData, setIBAData] = useState(IBAConfig);
    const [IBALogo, setIBALogo] = useState(null);
    const [displayFile, setdisplayFile] = useState("none");

    useEffect(() => {
        FetchIBAData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchIBAData = () => {
        Axiosfetch(baseURL + "GetActiveIBAData", "GET", null, IBADataSuccess, Failure);
    };

    const IBADataSuccess = (data) => {
        if (data.length > 0) {
            setIBAData(data[0]);
        }
        else {
            setIBAData(IBAConfig);
        }
    }

    const IBASuccess = (data) => {
        if (data.success) {
            setIBALogo(null);
            FetchIBAData();
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SaveIBADetails = () => {
        IBASchema.validate(IBAData).then(valid => {
            if (IBALogo !== null) {
                UploadIBAFile();
            }
            else {
                SaveIBA(null);
            }
        }).catch(err => {
            Alert.error(err.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        });
    };

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            setIBALogo(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const UploadIBAFile = () => {
        let formData = new FormData();
        formData.append('file', IBALogo);
        Axiosfetch(baseURL + "UploadIBALogo", "POST", formData, IBALogoSuccess, Failure);
    };

    const IBALogoSuccess = (data) => {
        if (data.success) {
            SaveIBA(data.filename);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SaveIBA = (filename) => {
        if (filename !== null) {
            IBAData.IBAFileName = filename;
        }

        if (ValidateIBA()) {
            var APIOperation = IBAData._id === undefined ? "CreateIBAConfig" : "EditIBAConfig";
            Axiosfetch(baseURL + APIOperation, "POST", IBAData, IBASuccess, Failure);
        }
    };

    const ValidateIBA = () => {
        let enqErr = "";
        if (IBAData.IBANumber.trim() === "") {
            enqErr = "Please enter IBA Number";
        }
        else if (IBAData.ContactNumber <= 0 || (IBAData.ContactNumber !== 0 && !/^[0-9]{10}$/.test(IBAData.ContactNumber.toString()))) {
            enqErr = "Please enter valid Contact Number";
        }
        else if (IBAData.AltContactNumber !== 0 && !/^[0-9]{10}$/.test(IBAData.AltContactNumber.toString())) {
            enqErr = "Please enter valid Alt Contact Number";
        }
        else if (IsUndefinedNullOrEmpty(IBAData.PANNumber) || (!IsUndefinedNullOrEmpty(IBAData.PANNumber) &&
            !/([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/.test(IBAData.PANNumber.toString()))) {
            enqErr = "Please enter valid PAN Number";
        }
        else if (!IsUndefinedNullOrEmpty(IBAData.PANNumber) && !IsUndefinedNullOrEmpty(IBAData.GSTNumber) &&
            IBAData.GSTNumber.toUpperCase().indexOf(IBAData.PANNumber.toUpperCase()) === -1) {
            enqErr = "Please enter valid GST Number";
        }
        else if (IBAData.IBAAddress.trim() === "") {
            enqErr = "Please enter valid Address";
        }
        else if (IBAData.BankName.trim() === "") {
            enqErr = "Please enter valid Bank Name";
        }
        else if (IBAData.Branch.trim() === "") {
            enqErr = "Please enter valid Branch";
        }
        else if (IBAData.AccountName.trim() === "") {
            enqErr = "Please enter valid Account Name";
        }
        else if (IBAData.AccountNumber === 0 || (IBAData.AccountNumber !== 0 && !/^[0-9]{9,18}$/.test(IBAData.AccountNumber.toString()))) {
            enqErr = "Please enter valid Account Number";
        }
        else if (IBAData.IFSCCode !== "" && !/^[A-Za-z]{4}[0][A-Z0-9]{6}$/.test(IBAData.IFSCCode.toString())) {
            enqErr = "Please enter valid IFSC Code";
        }
        else if (IBAData.AccountType === 0) {
            enqErr = "Please enter valid Account Type";
        }
        else if (IBAData.IBATerms.trim() === "") {
            enqErr = "Please enter IBA Terms and Conditions";
        }
        else if (IBAData.IBAFileName === null) {
            enqErr = "Please add IBA Logo";
        }

        if (enqErr !== "") {
            Alert.error(enqErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };



    const Failure = (err) => {
        FailureAlert(err);
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setIBAData({ ...IBAData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value;
        if (value !== "" && !isNaN(value)) {
            setIBAData({ ...IBAData, [e.target.name]: parseFloat(value) });
        }
        else {
            setIBAData({ ...IBAData, [e.target.name]: 0 });
        }
    };

    const RemoveIBALogoFile = () => {
        setIBALogo(null);
        setIBAData({ ...IBAData, "IBAFileName": "" });
    };

    const GetIBAFile = (Filename) => {
        if (Filename !== null) {
            Axiosfetch(baseURL + "GetIBAFile", "POST", { fileName: Filename }, FileSuccess, Failure);
        }
    };

    const FileSuccess = (data) => {
        if (data.success) {
            setIBALogo(data.fileData);
            setdisplayFile("block");
        }
    };

    const hideFileModal = () => {
        setdisplayFile("none");
    };

    const OnAccountTypeChange = (e) => {
        let AccountTypeValue = parseInt(e.target.value);
        setIBAData({ ...IBAData, [e.target.name]: AccountTypeValue });
    }

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row" style={{ height: "78vh", overflow: "auto", paddingBottom: "5px", margin: "5px" }}>
                    <div className="col-md-12 col-sm-12 col-12 align-center">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>IBA Configuration</h5>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <input type="text" placeholder="" name="IBANumber" value={IBAData.IBANumber}
                                onChange={(e) => onTextChange(e)}></input>
                            <span>IBA Number <span className="mandatoryStar">*</span></span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <input type="text" placeholder="" name="Website" value={IBAData.Website}
                                onChange={(e) => onTextChange(e)}></input>
                            <span>Website Address</span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <input type="text" placeholder="" name="ContactNumber" value={!isNaN(IBAData.ContactNumber) && IBAData.ContactNumber
                                && IBAData.ContactNumber > 0 ? IBAData.ContactNumber : ""}
                                onChange={(e) => onNumberChange(e)}></input>
                            <span>Contact<span className="mandatoryStar">*</span></span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <input type="text" placeholder="" name="AltContactNumber" value={!isNaN(IBAData.AltContactNumber) && IBAData.AltContactNumber
                                && IBAData.AltContactNumber > 0 ? IBAData.AltContactNumber : ""}
                                onChange={(e) => onNumberChange(e)}></input>
                            <span>Alternate Contact</span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <input type="text" placeholder="" name="EmailID" value={IBAData.EmailID}
                                onChange={(e) => onTextChange(e)}></input>
                            <span>Email ID<span className="mandatoryStar">*</span></span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <input type="text" placeholder="" name="AltEmailID" value={IBAData.AltEmailID}
                                onChange={(e) => onTextChange(e)}></input>
                            <span>Alternate Email ID</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="text-field">
                            <input placeholder="" name="PANNumber" value={IBAData.PANNumber ? IBAData.PANNumber : ""}
                                onChange={(e) => onTextChange(e)}
                                type="text"></input>
                            <span>PAN Number</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="text-field">
                            <input placeholder="" name="GSTNumber" value={IBAData.GSTNumber ? IBAData.GSTNumber : ""}
                                onChange={(e) => onTextChange(e)}
                                type="text"></input>
                            <span>GST Number</span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="text-field">
                            <textarea placeholder="" name="IBAAddress" value={IBAData.IBAAddress ? IBAData.IBAAddress : ""}
                                onChange={(e) => onTextChange(e)}
                                type="text"></textarea>
                            <span>Address</span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div style={{ marginBottom: "1rem", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div>
                                <h5 style={{ padding: "10px", backgroundColor: "#ddd" }}>Bank Details</h5>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="AccountName" value={IBAData.AccountName}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Account Name<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <select onChange={OnAccountTypeChange} value={(IBAData.AccountType ? IBAData.AccountType : 0)} name="AccountType" style={{ width: "90%", padding: "10px", margin: "10px" }}>
                                        <option value="0">Select Account Type</option>
                                        <option value="1">Current</option>
                                        <option value="2">Savings</option>
                                        <option value="3">CC</option>
                                        <option value="4">OD</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="BankName" value={IBAData.BankName}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Bank Name<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="AccountNumber" value={IBAData.AccountNumber}
                                            onChange={(e) => onNumberChange(e)}
                                            type="text"></input>
                                        <span>Bank Account<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="IFSCCode" value={IBAData.IFSCCode}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>IFSC Code<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-field">
                                        <input placeholder="" name="Branch" value={IBAData.Branch}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Branch<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-12 align-center">
                        <div className="text-field">
                            <textarea rows="5" placeholder="" name="IBATerms" value={IBAData.IBATerms}
                                onChange={(e) => onTextChange(e)}></textarea>
                            <span>Terms and Conditions <span className="mandatoryStar">*</span></span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-12 align-center" style={{ paddingTop: "20px", margin: "auto", display: "flex", justifyContent: "center" }}>
                        {(IBAData.IBAFileName === null || IBAData.IBAFileName === "") ? (<div style={{ width: "100%" }} className="text-field">
                            <input type="file" onChange={(e) => OnFileUpload(e)}></input>
                            <span>IBA Logo<span className="mandatoryStar">*</span></span>
                        </div>) :
                            (<div style={{ border: "none", width: "50%", position: "relative" }}>
                                <div style={{ borderRadius: "30px" }} onClick={() => GetIBAFile(IBAData.IBAFileName)} className="cursor" title="Click to see Profile Photo...">
                                    <img width="80" height="80" alt="Logo" src={`${baseURL}IBALogo/${IBAData.IBAFileName}`}></img>
                                </div>
                                <span onClick={RemoveIBALogoFile} style={{ position: "absolute", left: "80%", top: "0", fontSize: "20px", cursor: "pointer" }}><FontAwesomeIcon style={{ paddingRight: "2px" }} icon={faTimes} /></span>
                            </div>)}
                    </div>

                    <div className="col-md-12 col-sm-12 col-12 align-right">
                        <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveIBADetails}>Save</button>
                    </div>
                </div>
            </div>
            <div id="displayFileModal" className="modal" style={{ display: displayFile, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>IBA Logo</span>
                        <span className="close" onClick={hideFileModal}>&times;</span>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <img width="100%" height="400" alt="IBA Logo" src={IBALogo}></img>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IBA;
